import type { WmsShipmentInboundType } from 'schemas/shipment/inbound/detail';
import type { InboundDetailDisplay } from '@utility/utils/shipment-display';
import { InboundShipmentAttentionTab } from './InboundShipmentAttentionTab';
import { InboundShipmentCommentsTab } from './InboundShipmentCommentsTab';
import { InboundShipmentDocumentsTab } from './InboundShipmentDocumentsTab';
import { InboundShipmentInfoTab } from './InboundShipmentInfoTab';
import { InboundDetailSidebarTabs, SidebarDetailPanel } from './inboundDetailStyled';

type InboundShipmentSidebarProps = {
  data: WmsShipmentInboundType;
  display: InboundDetailDisplay;
  onRefresh: () => void;
};

export function InboundShipmentSidebar({
  data,
  display,
  onRefresh,
}: InboundShipmentSidebarProps) {
  return (
    <SidebarDetailPanel>
      <InboundDetailSidebarTabs
        defaultActiveKey="info"
        items={[
          {
            key: 'info',
            label: 'Info',
            children: <InboundShipmentInfoTab data={data} display={display} />,
          },
          {
            key: 'attention',
            label: 'Attention',
            children: <InboundShipmentAttentionTab data={data} onRefresh={onRefresh} />,
          },
          {
            key: 'documents',
            label: 'Documents',
            children: <InboundShipmentDocumentsTab data={data} onRefresh={onRefresh} />,
          },
          {
            key: 'comments',
            label: 'Comments',
            children: <InboundShipmentCommentsTab data={data} onRefresh={onRefresh} />,
          },
        ]}
      />
    </SidebarDetailPanel>
  );
}
